import autocomplete from './autocomplete';

const buildSearchUrl = (endpoint, query, collection = '') => {
    const separator = endpoint.includes('?') ? '&' : '?';
    const collectionQuery = collection.length > 0
        ? `&collection=${encodeURIComponent(collection)}`
        : '';

    return `${endpoint}${separator}q=${encodeURIComponent(query)}${collectionQuery}`;
};

const normalizeResult = (result) => ({
    value: result.url,
    url: result.url,
    keywords: [result.title, result.preview, result.type].filter(Boolean),
    data: result,
});

export default (props = {}) => autocomplete({
    allowCustomValue: true,
    collection: '',
    endpoint: '',
    fetcher: (...args) => fetch(...args),
    minCharacters: 2,
    options: [],
    searchPageUrl: '',

    async search(input) {
        const query = input.trim();

        if (query.length < this.minCharacters) {
            this.showNoResults = false;

            return this.handleResults([]);
        }

        const response = await this.fetcher(buildSearchUrl(this.endpoint, query, this.collection), {
            headers: {
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            this.showNoResults = false;

            return this.handleResults([]);
        }

        const results = (await response.json()).map(normalizeResult);
        this.showNoResults = results.length === 0;

        return this.handleResults(results);
    },

    handleSubmit(selectedResult) {
        if (selectedResult?.url) {
            window.location.assign(selectedResult.url);

            return;
        }

        if (!this.searchPageUrl) {
            return;
        }

        const query = this.$refs.search.value.trim();

        if (query.length === 0) {
            return;
        }

        const collectionQuery = this.collection.length > 0
            ? `&collection=${encodeURIComponent(this.collection)}`
            : '';

        window.location.assign(`${this.searchPageUrl}?q=${encodeURIComponent(query)}${collectionQuery}`);
    },

    resetSearch() {
        this.results = [];
        this.selectedIndex = null;
        this.selectedResult = null;
        this.resultListExpanded = false;
        this.showNoResults = false;
        this.collapsed = true;
        this.value = '';

        if (this.$refs.search) {
            this.$refs.search.value = '';
        }
    },

    toggleCollectionFilter(collection) {
        this.collection = this.collection === collection ? '' : collection;

        if (this.$refs.search?.value?.trim().length >= this.minCharacters) {
            this.handleInput(new Event('input'));
        } else {
            this.results = [];
            this.selectedIndex = null;
            this.selectedResult = null;
            this.resultListExpanded = false;
            this.showNoResults = false;
            this.collapsed = true;
        }
    },

    ...props,
});
